/**
 * Encode special characters
 * @param {string} str
 * @param {boolean} encode
 */
export const encodeSpecialCharacters = (str, encode = true) => {
    if (!encode) {
        return String(str);
    }
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#x27;');
};
/**
 * Массив или одиночное значение строкой
 * @param data
 * @param {string} delimiter
 */
export function flattenArray(data, delimiter = ' ') {
    return Array.isArray(data) ? data.join(delimiter) : data.toString();
}
/**
 * Создает хеш строки
 * @param string
 */
export function generateHash(string) {
    let hash = 0;
    if (string.length == 0) {
        return String(hash);
    }
    for (let i = 0; i < string.length; i++) {
        let charCode = string.charCodeAt(i);
        hash = (hash << 7) - hash + charCode;
        hash = hash & hash;
    }
    return String(hash);
}
